var _a;
import { ITEM_TYPES } from '../types/ItemTypes';
import { enrichWithSiteLevelData } from './utils';
import defaultAdapter from '../item-types/default/adapter-default';
import storesProductAdapter from '../item-types/stores-product/adapter-stores-product';
import staticPageAdapter from '../item-types/static-page/adapter-static-page';
import staticPageAdapterV2 from '../item-types/static-page-v2/adapter-static-page-v2';
import forumCategoryAdapter from '../item-types/forum-category/adapter-forum-category';
import forumPostAdapter from '../item-types/forum-post/adapter-forum-post';
import proGalleryItemAdapter from '../item-types/pro-gallery-item/adapter-pro-gallery-item';
import blogCategoryAdapter from '../item-types/blog-category/adapter-blog-category';
import blogPostAdapter from '../item-types/blog-post/adapter-blog-post';
import blogTagsAdapter from '../item-types/blog-tags/adapter-blog-tags';
import blogArchiveAdapter from '../item-types/blog-archive/adapter-blog-archive';
import groupsPostAdapter from '../item-types/groups-post/adapter-groups-post';
import groupsPageAdapter from '../item-types/groups-page/adapter-groups-page';
import eventsPageAdapter from '../item-types/events-page/adapter-events-page';
import challengesPageAdapter from '../item-types/challenges-page/adapter-challenges-page';
import bookingsServiceAdapter from '../item-types/bookings-service/adapter-bookings-service';
import breadcrumbsComponentAdapter from '../item-types/breadcrumbs-component/adapter-breadcrumbs-component';
var adapters = (_a = {},
    _a[ITEM_TYPES.STORES_PRODUCT] = storesProductAdapter,
    _a[ITEM_TYPES.STATIC_PAGE] = staticPageAdapter,
    _a[ITEM_TYPES.STATIC_PAGE_V2] = staticPageAdapterV2,
    _a[ITEM_TYPES.FORUM_CATEGORY] = forumCategoryAdapter,
    _a[ITEM_TYPES.FORUM_POST] = forumPostAdapter,
    _a[ITEM_TYPES.PRO_GALLERY_ITEM] = proGalleryItemAdapter,
    _a[ITEM_TYPES.BLOG_CATEGORY] = blogCategoryAdapter,
    _a[ITEM_TYPES.BLOG_POST] = blogPostAdapter,
    _a[ITEM_TYPES.BLOG_TAGS] = blogTagsAdapter,
    _a[ITEM_TYPES.BLOG_ARCHIVE] = blogArchiveAdapter,
    _a[ITEM_TYPES.GROUPS_POST] = groupsPostAdapter,
    _a[ITEM_TYPES.GROUPS_PAGE] = groupsPageAdapter,
    _a[ITEM_TYPES.EVENTS_PAGE] = eventsPageAdapter,
    _a[ITEM_TYPES.CHALLENGES_PAGE] = challengesPageAdapter,
    _a[ITEM_TYPES.BOOKINGS_SERVICE] = bookingsServiceAdapter,
    _a[ITEM_TYPES.BREADCRUMBS_COMPONENT] = breadcrumbsComponentAdapter,
    _a);
/**
 *
 * @param {keyof typeof ITEM_TYPES} itemType
 * @returns {import('../../../index').Adapter}
 */
export function getAdapter(itemType) {
    var adapter = adapters[itemType];
    return adapter ? enrichWithSiteLevelData(adapter) : defaultAdapter;
}
export var adaptersHandlers = {
    getData: 'function',
    getLegacySeoBlob: 'function',
    getBiData: 'function',
    getKeys: 'function',
    getSlug: 'function',
    updateItemDataWithSlug: 'function',
    getMissingSchemaVariables: 'function',
    getDynamicPatternsSchema: 'function',
};
export var optionalHandlers = ['getDynamicPatternsSchema'];
export var componentAdapterHandlers = {
    getData: 'function',
    getLegacySeoBlob: 'function',
    getBiData: 'function',
    getKeys: 'function',
    getMissingSchemaVariables: 'function',
};
